const consentCheckerKH = (dataSources, inputData) => {
  const consentObtained = {}; // COLLECTS USER CONSENTS

  // USER CONSENT CHECK
  if (dataSources.includes('Cambodia National ID')) {
    // CONSENT COLLECTOR
    consentObtained['Cambodia National ID'] = true;

    if (!inputData.consumerDataConsentObtained) {
      return { isConsent: false };
    }
  }

  return { consentObtained, isConsent: true };
};

export default consentCheckerKH;
